import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * Microsoftカレンダーの一覧の取得
 *
 * 連携したアカウントのカレンダー一覧を取得する
 */
export class FetchCalendarMicrosoft implements APIRequest<Monitaro.FetchCalendarMicrosoftResponse> {
  response: Monitaro.FetchCalendarMicrosoftResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/calendars/microsoft`
  }
}

/**
 * カレンダー連携を解除する
 *
 * 連携したMicrosoftカレンダーの連携を解除する
 */
export class DeleteCalendarMicrosoft implements APIRequest<Monitaro.DeleteCalendarMicrosoftResponse> {
  response: Monitaro.DeleteCalendarMicrosoftResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor() {
    this.path = `/calendars/microsoft`
  }
}

/**
 * Microsoftカレンダーの連携中のデータの数を返す
 *
 * 連携と削除の進捗を取得する
 */
export class RelationCalendarMicrosoft implements APIRequest<Monitaro.RelationCalendarMicrosoftResponse> {
  response: Monitaro.RelationCalendarMicrosoftResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(id: string) {
    this.path = `/calendars/microsoft/relation/${id}`
  }
}

/**
 * 選択されたカレンダーをIDを保存する
 *
 * 連携したMicrosoftカレンダーのどのカレンダーに連携するかを保存する
 */
export class PutCalendarMicrosoft implements APIRequest<Monitaro.PutCalendarMicrosoftResponse> {
  response: Monitaro.PutCalendarMicrosoftResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.MicrosoftCalendarRequest
  constructor(id: string, params: Monitaro.MicrosoftCalendarRequest) {
    this.params = params
    this.path = `/calendars/microsoft/${id}`
  }
}

/**
 * 連携したカレンダーデータを削除する
 *
 * 連携したMicrosoftカレンダーのイベントデータを削除する
 */
export class CleaningCalendarMicrosoft implements APIRequest<Monitaro.CleaningCalendarMicrosoftResponse> {
  response: Monitaro.CleaningCalendarMicrosoftResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(id: string) {
    this.path = `/calendars/microsoft/${id}`
  }
}
